import React from "react";

import Container from "@mui/material/Container";
import ApplicationPanel from "../../application/ApplicationPanel";
import ApplicationHeader from "../../application/ApplicationHeader";
import IpOverrideBrowse from "./IpOverrideBrowse";
import { AlertProvider } from "../../components/alert/AlertProvider";
import { createAppQueryClient } from "../../application/queryClients";
import { AppQueryClientProvider } from "../../application/AppQueryClientProvider";

// Create a client
const queryClient = createAppQueryClient({
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: Infinity,
});
const ManageIpOverrides = () => {
  return (
    <AlertProvider>
      <Container id="manage-ip-overrides" disableGutters>
        <ApplicationHeader />

        <ApplicationPanel>
          <AppQueryClientProvider client={queryClient}>
            <IpOverrideBrowse />
          </AppQueryClientProvider>
        </ApplicationPanel>
      </Container>
    </AlertProvider>
  );
};

export default ManageIpOverrides;
